// src/components/Dashboard/charts/ValidatedRequirementsByUserChart.tsx
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Empty } from "antd";

interface ValidatedRequirementsByUserChartProps {
  data: any[];
}

const ValidatedRequirementsByUserChart: React.FC<
  ValidatedRequirementsByUserChartProps
> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="flex justify-center items-center h-64">
        <Empty description="No data available" />
      </div>
    );
  }

  // Format the data for the chart
  const formattedData = data.map((item) => {
    const firstName = item.subfolder__folder__assigned_user__first_name || "";
    const lastName = item.subfolder__folder__assigned_user__last_name || "";
    const email = item.subfolder__folder__assigned_user__email || "";

    // Create display name
    let displayName = email;
    displayName = email.split("@")[0];
    if (firstName || lastName) {
      displayName = `${firstName} ${lastName}`.trim();
      // Keep it short
      if (displayName.length > 15) {
        displayName = `${displayName.substring(0, 15)}...`;
      }
    }
    return {
      name: displayName,
      count: item.count,
    };
  });

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 shadow-md rounded-md">
          <p className="font-medium text-gray-600">{label}</p>
          <p className="text-green-600">
            <span className="font-bold">{payload[0].value}</span> requisitos
            validados
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="h-64 w-full">
      <ResponsiveContainer>
        <BarChart
          data={formattedData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 30,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis
            dataKey="name"
            tick={{ fill: "#6b7280", fontSize: 12 }}
            tickLine={{ stroke: "#e5e7eb" }}
            axisLine={{ stroke: "#e5e7eb" }}
            angle={-45}
            textAnchor="end"
            height={60}
          />
          <YAxis
            tick={{ fill: "#6b7280" }}
            tickLine={{ stroke: "#e5e7eb" }}
            axisLine={{ stroke: "#e5e7eb" }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="count"
            fill="#0e4b54"
            radius={[4, 4, 0, 0]}
            className="hover:opacity-80 transition-opacity duration-300"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ValidatedRequirementsByUserChart;
